<template lang="pug">
  ods-module
    div(slot="header")
      span {{ this.$t('loyalty.templates') }}
      filter-table(
          layout="text"
          @inputSearchFilter="inputSearchFilter")
    div
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        height="50vh"
        size="medium"
        :data='tableDataRendered')
        ods-table-column(prop='NOMBRE' :label="this.$t('loyalty.name')")
          template(slot-scope="scope")
            div {{ scope.row.descripcion }}
        ods-table-column(prop='FECINI' :label="this.$t('loyalty.startDate')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.fechaici | formatDateLocale }}
        ods-table-column(prop='FECFIN' :label="this.$t('loyalty.endDate')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.fechafin | formatDateLocale }}
        ods-table-column(prop='IMPMIN' :label="this.$t('loyalty.minimumAmount')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.imp_minimo }}
        ods-table-column(prop='MAXCUP' :label="this.$t('loyalty.maxCoupon')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.num_max_cup }}
        ods-table-column(prop='CUPONESASIG' :label="this.$t('loyalty.couponsAssigned')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.num_cup_act }}
        ods-table-column(width='55')
          template(slot-scope='scope')
            router-link(:to="{name: namePath }")
              ods-button(type="text" size="mini" icon='ods-icon-eye' @click="guardarCodplantilla(scope.row.cod_plantilla)" )
      div.footer
        paginator(v-if="indMasDatos!=='N' && currentPage!=='1'"
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PlantillasTable',
  components: {
    Paginator,
    FilterTable
  },
  data () {
    return {
      // estaba a true hasta que tenga datos
      loadingTable: false,
      tableDataRendered: this.datatable,
      tableData: this.datatable,
      currentPage: this.paginaactual,
      indMasDatos: this.masdatos,
      paginationParams: this.parampagination,
      activePagination: true,
      namePath: 'TemplatesDetails'
    }
  },
  computed: {
    ...mapGetters({
      loadingProgram: 'getProgramState',
      appProgramTitle: 'getSelectedProgram'
    })
  },
  methods: {
    ...mapActions(['getTemplates', 'getProgram', 'setCodPlantilla']),
    async getData (params) {
      this.loadingTable = true
      // console.log('HEIN')
      // console.log(params)
      const response = await this.getTemplates(params)
      if (response && response.registros && response.registros.length) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      } else {
        this.tableData = null
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      }
      this.currentPage = response ? response.pantPagina : null
      this.indMasDatos = response ? response.indMasDatos : null
      this.paginationParams = {
        claveInicio: response ? response.claveInicio : '',
        claveFin: response ? response.claveFin : ''
      }
    },
    inputSearchFilter (text) {
      // console.log('inputSearchFilter')
      this.tableDataRendered = this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    },
    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.activePagination = true
      this.getData(params)
    },
    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.activePagination = true
      this.getData(params)
    },
    guardarCodplantilla (text) {
      // console.log('guardarCodplantilla')
      this.setCodPlantilla(text)
      // sessionStorage.setItem('Codplantilla', text)
    }
  },
  watch: {
    async activarPlantillas (newVal, oldVal) {
      if (newVal) {
        // console.log('activarPlantillas')
        await this.getData()
      }
    },
    async loadingProgram (data, oldData) {
      // console.log('data, oldData')
      if (data && this.activarPlantillas) {
        // console.log('loadingProgram if')
        await this.getData()
      } else {
        // console.log('loadingProgram else')
        if (data && this.activePagination) {
          // console.log('loadingProgram holi')
          const params = {
            avanzar: false
          }
          await this.getData(params)
        }
      }
    },
    async appProgramTitle (data, oldData) {
      // console.log('appProgramTitle')
      this.templateIsChange = false
      this.oldProgram = oldData
      const response = await this.getProgram()
      this.data = response
      return this.data
    }
  },
  async mounted () {
    // console.log('lomonta')
    const params = {
      ...this.defaultParams,
      ...this.paginationParams,
      avanzar: false
    }
    this.activePagination = true
    this.getData(params)
  }
}
</script>
